registerComponent("sections/home-contents", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * O slick de 2020 (`slidesToShow: 3` / `slidesToScroll: 3`, `1` a partir do
 * `breakpoint: 767`, `infinite: false`) vira um `Asa.trilho`. O degrau mora no
 * `_home-contents.less` e o trilho o lê de lá: nenhum `matchMedia` aqui.
 *
 * ⚠️ UMA caixa de pontos, não duas. O legado lia `.slider-dots-desk` e o
 * passava como `appendDots` fora do celular — mas ESTE Blade nunca renderizou
 * esse elemento (só `sections/home-videos` e `sections/home-insights` têm), e
 * o slick anexava a uma coleção vazia: no desktop não havia ponto nenhum. Não é
 * regressão da transposição, é o estado de 2020; e a folha esconde o
 * `blocks/slider-controls` inteiro fora do celular, então nada aparece ali de
 * qualquer forma. O arquivo da Fase 7 supõe os dois contêineres — ver a
 * correção no programa.
 *
 * ⚠️ O `breakpoint: 767` do slick valia abaixo de 767 (`windowWidth <
 * breakpoint`), enquanto o `@legacy-maxSm` da folha vale até 767 inclusive: em
 * 767 px exatos o legado tinha o layout de celular com o carrossel de desktop.
 * Agora os dois coincidem. Nenhuma largura do baseline está em 767.
 */

const lista = component.querySelector('.slider');

if (lista) {
    Asa.trilho(lista, Object.assign(
        { itens: '[data-component-name="blocks/card-content"]', passo: 'pagina' },
        Asa.controlesDoTrilho(component.querySelector('[data-component-name="blocks/slider-controls"]')),
    ));
}

});
